import _ from "lodash";

export const sortDataForClonedCampaign = (data, clonedCampaignData) => {
	const clonedData = _.cloneDeep(data);
	const masterCampaignIndex = clonedData?.findIndex(({ MasterCampaignID }) => MasterCampaignID == clonedCampaignData?.targetMasterCampaignID);
	const masterCampaignData = clonedData[masterCampaignIndex];
	clonedData.splice(masterCampaignIndex, 1);
	clonedData.unshift(masterCampaignData);
	return clonedData;
};

export const resetCloneHighlighting = () => {
	try {
		const previouslyCloned = Array.from(document.querySelectorAll(".recently-cloned"));
		previouslyCloned.forEach((el) => el?.classList?.remove?.("recently-cloned"));
	} catch (e) {}
};

// handle clone highlighting with vanilla js. We must do this because the data table does not expose the underlying accordion control to us, or its ref.
export const highlightClonedCampaign = (masterCampaignID) => {
	try {
		const table = document.querySelectorAll("#overview-table .gos-dt-tbody .gos-dt-tr__content");
		const targetMasterCampaign = Array.from(table).find((row) => {
			return row.querySelector("td[data-bind='CampaignID'] input")?.value == masterCampaignID;
		});
		targetMasterCampaign?.classList?.add("highlighted-table-row");
		// expand the first accordion, the master campaign containing the cloned activation campaign was previously sorted to the top (index 0)
		// const firstAccordionContent = document.querySelector(".gos-dt-tr__accordion .gos-accordion-content");
		// if (firstAccordionContent) {
		//  //expand the row
		//  // firstAccordionContent?.classList?.remove("gos-accordion-content__closed");
		//  // firstAccordionContent?.classList?.add("gos-accordion-content__open");

		//  //get the grids that have been rendered, we're going to look through them for the platform containing the row with the expected data
		//  const grids = Array.from(firstAccordionContent?.querySelectorAll(".headless-grid"));

		//  //find the grid with the matching title
		//  const rows = Array.from(
		//      grids.find((el) => el?.querySelector?.(".platform-title")?.innerText?.toLowerCase?.() == platformName?.toLowerCase?.())?.querySelector?.(".gos-dt-tbody")?.children
		//  );

		//  //find the row with the matching campaignId on it's checkbox
		//  const row = rows?.find((r) => r?.querySelector?.(`.gos-chk input[id="${activationCampaignId}"]`));

		//  if (row) {
		//      //first clear all existing nodes with the style
		//      resetCloneHighlighting();

		//      //then apply the scroll & style to the new row
		//      row?.scrollIntoViewIfNeeded?.();
		//      row?.classList?.add?.("recently-cloned");
		//  }
		// }
	} catch (e) {
		console.log("An error occurred while clone highlighting");
		console.log(e);
	}
};

// highlight the activation campaign after triggering the master campaign accordion
export const highlightClonedActivationCampaign = (campaignID) => {
	try {
		const expandedAccordionTable = document.querySelector("#overview-table .gos-dt-tbody-middle");
		const clonedActivationCampaign = Array.from(expandedAccordionTable?.children).find((activationCampaignRow) => {
			return activationCampaignRow.querySelector("td[data-bind='CampaignID'] input")?.value == campaignID;
		});
		if (clonedActivationCampaign) {
			clonedActivationCampaign?.classList?.add("highlighted-table-row");
		}
	} catch (e) {
		console.log("An error occurred while clone highlighting");
		console.log(e);
	}
};
